<template>
    <Page :header="header[lang].title" type="gray">
        <template v-slot:body>
            <MobMenu :items="menu"/>
        </template> 
    </Page>
</template>

<script>
import Connect          from '@/assets/js/Connect'
import Helper           from '@/assets/js/Helper'
import Page             from '@/components/sides/Page.vue' 
import MobMenu          from '@/components/sides/menu/MobMenu.vue'
import { mapActions }   from 'vuex'

export default {
    data() {
        return {
            header: {
                en: {title: "Admin"} ,
                ru: {title: "Админ"} ,
            },
            menu: [
                {
                    href: '/admin/balances/',
                    label: {
                        ru: 'Балансы',
                        en: 'Balances'
                    },
                    labelIcon: 'pi pi-chart-pie',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/stat/',
                    label: {
                        ru: 'Статистика',
                        en: 'Statistics'
                    },
                    labelIcon: 'pi pi-chart-bar',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/merchants/',
                    label: {
                        ru: 'Мерчанты',
                        en: 'Merchants'
                    },
                    labelIcon: 'pi pi-sitemap',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/transfers/',
                    label: {
                        ru: 'Переводы',
                        en: 'Transfers'
                    },
                    labelIcon: 'pi pi-send',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/operations/',
                    label: {
                        ru: 'Операции',
                        en: 'Operations'
                    },
                    labelIcon: 'pi pi-cog',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/users/',
                    label: {
                        ru: 'Пользователи',
                        en: 'Users'
                    },
                    labelIcon: 'pi pi-users',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/partners/',
                    label: {
                        ru: 'Партнеры',
                        en: 'Partners'
                    },
                    labelIcon: 'pi pi-gift',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/vcards/',
                    label: {
                        ru: 'Карты',
                        en: 'Cards'
                    },
                    labelIcon: 'pi pi-credit-card',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/wallets/',
                    label: {
                        ru: 'Кошельки',
                        en: 'Wallets'
                    },
                    labelIcon: 'pi pi-wallet',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/accounts/',
                    label: {
                        ru: 'Счета',
                        en: 'Accounts'
                    },
                    labelIcon: 'pi pi-list',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/transactions/',
                    label: {
                        ru: 'Транзакции',
                        en: 'Transactions'
                    },
                    labelIcon: 'pi pi-receipt',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/rates/',
                    label: {
                        ru: 'Курсы',
                        en: 'Rates'
                    },
                    labelIcon: 'pi pi-percentage',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/banks/',
                    label: {
                        ru: 'Банки',
                        en: 'Banks'
                    },
                    labelIcon: 'pi pi-shop',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/pays/',
                    label: {
                        ru: 'Платежные системы',
                        en: 'Pays'
                    },
                    labelIcon: 'pi pi-table',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/files/',
                    label: {
                        ru: 'Файлы',
                        en: 'Files'
                    },
                    labelIcon: 'pi pi-file',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/senders/',
                    label: {
                        ru: 'Отправители',
                        en: 'Senders'
                    },
                    labelIcon: 'pi pi-arrow-up',
                    btnIcon: 'pi pi-angle-right'
                },
                {
                    href: '/admin/recipients/',
                    label: {
                        ru: 'Получатели',
                        en: 'Recipients'
                    },
                    labelIcon: 'pi pi-arrow-down',
                    btnIcon: 'pi pi-angle-right'
                },
            ]
        }
    },
    components: {
        Page,
        MobMenu
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        updateHeader() {
            this.UpdateHeader({
                title: this.header[this.lang].title,
                backButton: true,
                backButtonUrl: '/personal/products/',
                profileButton: false
            });
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppBackButton(false)

        try {
            this.SetHeaderTitle('Админ')
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    },
}
</script>